module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/admissions/testimonial_ashley-2c9f4285c12891144ff75b23f408b655.jpg";